import { render, staticRenderFns } from "./DropdownMenuButton.vue?vue&type=template&id=3a888535"
import script from "./DropdownMenuButton.vue?vue&type=script&lang=js"
export * from "./DropdownMenuButton.vue?vue&type=script&lang=js"
import style0 from "./DropdownMenuButton.vue?vue&type=style&index=0&id=3a888535&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports